import React from 'react'

import './loadSendReceiveData.css'
const LoadingSendReceiveData =()=>{

    return(
        <>
            <div className="contentLoadData">
                <div className="loadingDataLeft ">
                </div>
            </div>
        </>
    )
}

export default LoadingSendReceiveData;